// extracted by mini-css-extract-plugin
export default {"header-text":"styles_header-text__EYU+T","h1":"styles_h1__tyiOl","root":"styles_root__Er5Sy"};